import { Config } from '../config';
import { HttpService } from './http.service';
import { CommandHistoryEntry, DeviceCommand, IssueCommandResponse, SearchCommandsRequest, SearchCommandsResponse } from '../interfaces';

const path = Config.MESSENGER_API;

export abstract class CommandService {
  public static getTemplates = (): Promise<[]> => {
    return HttpService.fetchAuthorized(`${path}/commands/templates`).then((res) => {
      return res || [];
    });
  };

  public static issueCommand = (payload: any): Promise<IssueCommandResponse> => {
    return HttpService.fetchAuthorized(`${path}/commands/issue`, {
      method: 'POST',
      body: JSON.stringify(payload),
    }).then((res) => res || []);
  };

  public static getDeviceCommands = (deviceId: string): Promise<{ commands: DeviceCommand[] }> => {
    return HttpService.fetchAuthorized(`${path}/devices/${deviceId}/commands`).then((res) => res || { commands: [] });
  };

  public static getCommandHistory = (commandId: string): Promise<CommandHistoryEntry[]> => {
    return HttpService.fetchAuthorized(`${path}/commands/${commandId}/history`).then((res) => res || []);
  };

  public static searchCommands = (filters: SearchCommandsRequest, size: number, page: number): Promise<SearchCommandsResponse> => {
    return HttpService.fetchAuthorized(`${path}/commands/search?size=${size}&page=${page}`, {
      method: 'POST',
      body: JSON.stringify(filters),
    }).then((res) => res || { items: [], total_pages: 0, total_items: 0 });
  };
}
